import { Stack } from '@mui/material';
import { createContext, ReactNode, useContext, useMemo, useState } from 'react';

interface IToggleButtonContextProps {
  currentValue: string;
  setValue(value: string): void;
}

const ToggleButtonContext = createContext<IToggleButtonContextProps>({
  currentValue: '',
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  setValue: (value: string) => {},
});

export const useToggleButton = () => {
  return useContext(ToggleButtonContext);
};

export interface ToggleButtonGroupProps {
  defaultValue?: string;
  children: ReactNode;
  onClick?: (value: string) => void;
}

export function ToggleButtonGroup({
  defaultValue = '',
  children,
  onClick,
}: ToggleButtonGroupProps) {
  const [currentValue, setValue] = useState(defaultValue);
  useMemo(() => {
    if (currentValue) {
      onClick?.(currentValue);
    }
  }, [currentValue]);
  return (
    <ToggleButtonContext.Provider value={{ currentValue, setValue }}>
      <Stack direction="row" spacing={2}>
        {children}
      </Stack>
    </ToggleButtonContext.Provider>
  );
}
